<!-- Modal para añadir/editar usuario extraído -->
<div class="modal-content bg-white rounded-4 shadow-lg p-0">
  <div class="modal-header bg-secondary text-white d-flex align-items-center justify-content-between py-4 px-4 rounded-top">
    <div class="d-flex align-items-center gap-3">
      <span class="rounded-circle d-flex align-items-center justify-content-center me-3" style="width:56px;height:56px;background:var(--bs-primary);">
        <i class="fas" [class.fa-user-plus]="!editing" [class.fa-user-edit]="editing" style="font-size:1.75rem;"></i>
      </span>
      <div>
        <h5 class="modal-title mb-0 fw-bold">
          {{ editing ? 'Editar Usuario' : 'Nuevo Usuario' }}
        </h5>
        <p class="mb-0 opacity-75 small">
          {{ editing ? 'Modifica la información del usuario' : 'Introduce los datos del nuevo usuario' }}
        </p>
      </div>
    </div>
    <button type="button" class="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center" (click)="closeModal()" style="width:36px;height:36px;">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="modal-body p-4">
    <form class="d-flex flex-column gap-4">
      <!-- Nombre -->
      <div class="mb-3">
        <label class="form-label fw-semibold">
          <i class="fas fa-user text-primary me-2"></i>
          Nombre Completo <span class="text-danger fw-bold">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="user.name"
          name="userName"
          placeholder="Juan Pérez García">
      </div>

      <!-- Email y Teléfono en fila -->
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label fw-semibold">
            <i class="fas fa-envelope text-primary me-2"></i>
            Email
          </label>
          <input
            type="email"
            class="form-control"
            [(ngModel)]="user.email"
            name="userEmail"
            placeholder="usuario@ejemplo.com"
            required>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold">
            <i class="fas fa-phone text-primary me-2"></i>
            Teléfono
          </label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="user.phone"
            name="userPhone"
            placeholder="+34 600 000 000">
        </div>
      </div>

      <!-- Grupo y Fecha de Expiración en fila -->
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label fw-semibold">
            <i class="fas fa-users text-primary me-2"></i>
            Grupo
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="user.grupo"
            name="userGroup"
            placeholder="Ej: VIP, Premium, Básico">
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold">
            <i class="fas fa-calendar-times text-primary me-2"></i>
            Fecha de Expiración
          </label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="user.expiredDate"
            name="userExpiredDate"
            [min]="getTodayDate()">
          <div class="form-text">
            <i class="fas fa-info-circle text-primary me-2"></i>
            Dejar vacío para sin límite
          </div>
        </div>
      </div>

      <!-- Estado Activo -->
      <div class="mb-3">
        <div class="d-flex align-items-center justify-content-between p-3 bg-light border rounded">
          <div class="d-flex align-items-center gap-3">
            <i class="fas fa-power-off text-primary" style="font-size:1.5rem;"></i>
            <div>
              <div class="fw-semibold">Estado del Usuario</div>
              <div class="text-muted small">
                {{ user.active ? 'Usuario activo y operativo' : 'Usuario desactivado temporalmente' }}
              </div>
            </div>
          </div>
          <div>
            <label class="form-switch">
              <input type="checkbox" [(ngModel)]="user.active" name="userActive" class="form-check-input text-primary">
            </label>
          </div>
        </div>
      </div>

      <!-- Información adicional -->
      <div class="alert alert-warning bg-white d-flex align-items-center gap-3 py-3 px-4 mb-0 border border-warning rounded-3 shadow-sm" style="color:#333;">
        <i class="fas fa-lightbulb" style="font-size:1.5rem;color:#ffe066;"></i>
        <span class="text-secondary" style="font-size:1.1rem;">
          Los campos marcados con <span class="text-danger bg-white px-2 py-1 rounded-2 fw-bold">*</span> son obligatorios
        </span>
      </div>
    </form>
  </div>

  <div class="modal-footer bg-white border-top d-flex gap-2 justify-content-end rounded-bottom p-4">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      <i class="fas fa-times me-2"></i>
      Cancelar
    </button>
    <button type="button" class="btn btn-primary" (click)="saveModal()">
      <i class="fas fa-save me-2"></i>
      {{ editing ? 'Actualizar Usuario' : 'Crear Usuario' }}
    </button>
  </div>
</div>
